import React, { useContext } from 'react';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import Banner from '@atlaskit/banner';
import ErrorIcon from '@atlaskit/icon/glyph/error';

import { JiraAdminSettings } from '@qality/common-components';
import Loading from '@qality/common-components/src/atoms/Loading/Loading';
import { ProjectSettings } from '@qality/common-components/src/organisms/ProjectSettings';
import { ProjectSettingsHeader } from '@qality/common-components/src/settings/ProjectSettingsHeader';
import { FEATURE_FLAG } from '@qality/common-config';
import { messages } from '@qality/common-messages';
import { StorageOfUniqueServices } from '@qality/common-service';
import { QAlitySettingsContext } from '@qality/common-state/src/QAlitySettingsProvider/QAlitySettingsContext';

import {
  JiraAdminSettingsSection,
  LoadingWrapper,
  ProjectSettingsSection,
  Section,
  SectionBox,
  SectionName,
} from './Settings.styled';

const Settings: React.FC = () => {
  const { isJiraAdminUser, hasRightsToSeeSettings, loading, isInitialized } =
    useContext(QAlitySettingsContext);

  const getJiraAdminSettingSection = () => {
    return isJiraAdminUser ? (
      <JiraAdminSettingsSection>
        <JiraAdminSettings />
      </JiraAdminSettingsSection>
    ) : null;
  };

  const getSettingsContent = () => {
    return hasRightsToSeeSettings ? (
      <ProjectSettingsSection>
        <ProjectSettingsHeader />
        <ProjectSettings />
      </ProjectSettingsSection>
    ) : (
      <SectionBox>
        <Banner
          icon={<ErrorIcon label='Error icon' secondaryColor='inherit' />}
          isOpen
          appearance='error'
        >
          {messages['page.settings.noAccess.msg']}
        </Banner>
      </SectionBox>
    );
  };

  const nameSuffix = FEATURE_FLAG.isPremium ? 'Plus' : '';

  StorageOfUniqueServices.get('AP').sizeToParent(true);
  if (loading && !isInitialized) {
    return (
      <Section>
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      </Section>
    );
  } else {
    return (
      <Section>
        {loading && (
          <LoadingWrapper>
            <Loading />
          </LoadingWrapper>
        )}
        <SectionName>
          <h1>{`QAlity ${nameSuffix} Settings`}</h1>
        </SectionName>
        {getJiraAdminSettingSection()}
        {getSettingsContent()}
      </Section>
    );
  }
};

export default Settings;
